module.exports = "/images/lease-expiration-background.png?42f166be4382e38f1313c32da8b98437";